export const ROUTE_SEGMENTS = {
  home: '',
  auth: {
    root: 'auth',
    login: 'login',
    adminLogin: 'admin-login',
    adminForgotPassword: 'admin-forgot-password',
    verifyEmail: 'verify-email',
    signup: 'signup',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
  },
  admin: {
    root: 'admin',
    dashboard: 'dashboard',
    projects: 'projects',
    builders: 'builders',
    subscriptions: 'subscriptions',
    support: 'support',
    settings: 'settings',
  },
  builder: {
    root: 'builder',
    dashboard: 'dashboard',
    projects: 'projects',
    subscriptions: 'subscriptions',
    profile: 'profile',
    support: 'support',
    settings: 'settings',
  },
  pricingReport: 'pricing-report',
  notFound: '**',
} as const;

export const APP_ROUTES = {
  home: '/',
  auth: {
    root: '/auth',
    login: '/auth/login',
    adminLogin: '/auth/admin-login',
    adminForgotPassword: '/auth/admin-forgot-password',
    verifyEmail: '/auth/verify-email',
    signup: '/auth/signup',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  admin: {
    root: '/admin',
    dashboard: '/admin/dashboard',
    projects: '/admin/projects',
    builders: '/admin/builders',
    subscriptions: '/admin/subscriptions',
    support: '/admin/support',
    settings: '/admin/settings',
  },
  builder: {
    root: '/builder',
    dashboard: '/builder/dashboard',
    projects: '/builder/projects',
    subscriptions: '/builder/subscriptions',
    profile: '/builder/profile',
    support: '/builder/support',
    settings: '/builder/settings',
  },
  pricingReport: '/pricing-report',
} as const;
